export default __webpack_public_path__ + "assets/25b6139cf9e7716f2b2a5b329adb5670.png";